import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { RoleBadge, TextTooltip } from "@transfr-inc/dashboard-components";
import { Product } from "@transfr-inc/dashboard-components/constants";
import {
  Button,
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
  ToggleButton,
} from "@transfr-inc/dashboard-components/forms";
import { getLearnerTerm } from "@transfr-inc/dashboard-components/constants";

import { getRoleAvatarColor, Role } from "@models/role";
import { useCurrentUser, useRole } from "@queries";

import "./profile.scss";

export function ProfileInformation({
  onResetClick,
  onEditNotificationPreferences,
  user,
}) {
  const role = useRole();
  const currentUser = useCurrentUser();
  const { firstName, lastName, email, username, notificationPreferences } =
    user;

  const onCeseEmailNotificationsToggle = (value) => {
    onEditNotificationPreferences({
      ...notificationPreferences,
      cesePlanSubmittedEmail: value,
    });
  };
  const onCeseSummaryEmailCadenceSelected = (value) => {
    onEditNotificationPreferences({
      ...notificationPreferences,
      ceseSummaryEmailCadence: value,
    });
  };
  const onCeseSummaryEmailCadenceToggle = (value) => {
    onCeseSummaryEmailCadenceSelected(value ? "weekly" : "never");
  };

  return (
    <div className="profile-information">
      <div className="top">
        <div className="avatar">
          <FontAwesomeIcon className="avatar-icon" icon="fa-regular fa-user" />
        </div>
        <h1 className="name-header">
          {firstName} {lastName}
        </h1>
        <div className="name-subheader">{email}</div>
        {role == Role.STUDENT.id && (
          <div className="name-subheader">{username}</div>
        )}
      </div>
      <div className="bottom">
        <div className="box-section">
          <h6 className="section-name">USER TYPE</h6>
          <RoleBadge role={role} fillColor={getRoleAvatarColor(role)} />
        </div>
        <div className="box-section">
          <h6 className="section-name password">PASSWORD</h6>
          <Button
            icon="fa-regular fa-lock-keyhole"
            onClick={() => onResetClick(true)}
          >
            {role == Role.STUDENT.id ? "Change Password" : "Reset Password"}
          </Button>
        </div>
        {[Role.ORG_ADMIN.id, Role.INSTRUCTOR.id].includes(role) &&
          currentUser.products.includes(Product.TRK) && (
            <>
              <div className="box-section">
                <h6 className="section-name">
                  TREK NOTIFICATIONS
                  <TextTooltip
                    text={`Get notified when ${getLearnerTerm({
                      lowercase: true,
                      plural: true,
                    })} submit their plan`}
                  >
                    <FontAwesomeIcon icon={"fa-regular fa-circle-info"} />
                  </TextTooltip>
                </h6>
                <ToggleButton
                  onChange={onCeseEmailNotificationsToggle}
                  value={
                    notificationPreferences?.cesePlanSubmittedEmail ?? true
                  }
                  affirmText="ON"
                  negateText="OFF"
                />
              </div>
              <div className="box-section cese-summary-emails">
                <h6 className="section-name">
                  TREK SUMMARY EMAILS
                  <TextTooltip text="Get an email summary of your Trek classrooms">
                    <FontAwesomeIcon icon={"fa-regular fa-circle-info"} />
                  </TextTooltip>
                </h6>
                <div className="toggle-dropdown">
                  <ToggleButton
                    onChange={onCeseSummaryEmailCadenceToggle}
                    value={
                      notificationPreferences?.ceseSummaryEmailCadence !==
                      "never"
                    }
                    affirmText="ON"
                    negateText="OFF"
                  />
                  <Dropdown
                    selected={
                      notificationPreferences?.ceseSummaryEmailCadence ??
                      "weekly"
                    }
                    onOptionSelected={onCeseSummaryEmailCadenceSelected}
                  >
                    <DropdownButton>
                      {notificationPreferences?.ceseSummaryEmailCadence ??
                        "weekly"}
                    </DropdownButton>
                    <DropdownItems>
                      <DropdownItem value="weekly">Weekly</DropdownItem>
                      <DropdownItem value="bi-weekly">Bi-Weekly</DropdownItem>
                      <DropdownItem value="monthly">Monthly</DropdownItem>
                      <DropdownItem value="never">Never</DropdownItem>
                    </DropdownItems>
                  </Dropdown>
                </div>
              </div>
            </>
          )}
        <div className="box-section last">
          <h6 className="section-name">ORGANIZATION</h6>
          <div className="org-name">{currentUser.organizationName}</div>
        </div>
      </div>
    </div>
  );
}
